// eslint-disable-next-line import/prefer-default-export
export const calculateProgressValue = (
  currentPage,
  totalPages,
  submissionPageNumber
) => {
  if (typeof submissionPageNumber === 'number') {
    return Math.round((100 / (submissionPageNumber + 1)) * currentPage);
  }

  return Math.round((100 / totalPages) * currentPage);
};
